import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import MyContainer from "../../../MyContainer";
import { useNewsletterSectionStyles } from "./NewsletterSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { submitNewsletterSignup } from "../../../../api/api.form";

const NewsletterSection = () => {
    const { classes } = useNewsletterSectionStyles();
    const { t } = useI18n();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        setStatus("idle");
        const result = await submitNewsletterSignup(email);
        setLoading(false);
        if (result.success) {
            setStatus("success");
            setEmail("");
        } else {
            setStatus("error");
        }
    };

    return (
        <Box className={classes.root}>
            <MyContainer>
                <Box className={classes.inner}>
                    <Typography variant="h2" className={classes.title}>
                        {t("home.newsletterSection.title")}
                    </Typography>
                    <Typography variant="body1" className={classes.description}>
                        {t("home.newsletterSection.description")}
                    </Typography>

                    {status === "success" ? (
                        <Alert severity="success" sx={{ borderRadius: "12px" }}>
                            {t("home.newsletterSection.successMessage")}
                        </Alert>
                    ) : (
                        <Box component="form" className={classes.form} onSubmit={handleSubmit}>
                            <TextField
                                className={classes.input}
                                type="email"
                                required
                                placeholder={t("home.newsletterSection.placeholder")}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                size="small"
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={loading}
                                startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                            >
                                {t("home.newsletterSection.cta")}
                            </Button>
                        </Box>
                    )}
                    {status === "error" && (
                        <Alert severity="error" sx={{ borderRadius: "12px", mt: 2 }}>
                            {t("home.newsletterSection.errorMessage")}
                        </Alert>
                    )}

                    <Typography className={classes.disclaimer}>
                        {t("home.newsletterSection.disclaimer")}
                    </Typography>
                </Box>
            </MyContainer>
        </Box>
    );
};

export default NewsletterSection;
